import React, { useState } from 'react';
import { connect } from 'react-redux';
import cx from 'classnames';
import { Field, Form, reduxForm } from 'redux-form';

import Btn from '../../global/button';
import FormInputText from '../../global/form-input-text';
import FormOtpLoginError from '../form-otp-login-error';
import LoadingScreen from '../../global/loading-screen';
import Pictogram from '../../global/pictogram';
import TranslatedCopy from '../../../intl/translated-copy';
import UserProfileRecoverPasswordSuccess from './user-profile-recover-password-success';
import UserProfileErrorDisconnection from '../user-profile-error-disconnection';

import { checkPinCodeLength, hasConsecutiveDigits, hasSequential } from '../../../validation/user-profile/user-profile-nip/user-profile-nip-validations';
import { otpRecoverPinTypeErrors, recoverPinMicroTypeErrors } from '../../../constants/user-profile-recover-pin-codes';
import { USER_PROFILE_RECOVER_PIN_FORM_ID } from '../../../constants/form-ids';
import userProfilePinValidation from '../../../validation/user-profile/user-profile-nip/user-profile-nip-validatior';
import { otpRecoverPasswordTypeErrors, recoverPasswordMicroTypeErrors } from '../../../constants/user-profile-recover-password-codes';
import { submitAccountPasswordPinReset } from '../../../../redux/actions';

function UserProfileRecoverPinForm(props) {
  const {
    invalid,
    onBackButtonClick,
    onCloseModal,
    onSubmitForm,
    profileRecoverPasswordPin: {
      recoverPasswordPinError = null,
      recoverPasswordLoading,
      recoverPasswordPinSent = null,
    },
  } = props;

  const [data, setData] = useState({
    confirmPin: '',
    newPin: '',
  });

  const pinDigitsValidation = checkPinCodeLength(data.newPin);
  const pinConsecutiveDigitsValidation = hasConsecutiveDigits(data.newPin);
  const pinSequentialDigitsValidation = hasSequential(data.newPin);
  const isMatch = pinDigitsValidation && pinConsecutiveDigitsValidation && pinSequentialDigitsValidation;

  const pinNumberRules = [
    { copyId: 'PIN_DIGITS', matchRule: pinDigitsValidation },
    { copyId: 'PIN_CONSECUTIVE_NUMBERS', matchRule: pinConsecutiveDigitsValidation },
    { copyId: 'PIN_SEQUENTIAL_NUMBERS', matchRule: pinSequentialDigitsValidation },
  ];

  const handleChange = (event, name) => {
    const value = event.target.value;

    setData({ ...data, [name]: value });
  };

  const submitPinCode = () => {
    const { confirmPin } = data;

    onSubmitForm(confirmPin);
  };

  const handleOnRetryOtp = () => {
    const {
      dispatch,
    } = props;

    const otpError = Boolean(otpRecoverPasswordTypeErrors.includes(code));
    const microError = Boolean(recoverPasswordMicroTypeErrors.includes(code));

    dispatch(submitAccountPasswordPinReset());
    onBackButtonClick({ otpError, microError });
  };

  const {
    maskedEmail = null,
  } = recoverPasswordPinSent || {};

  const {
    code = null,
  } = recoverPasswordPinError || {};

  const showLoading = Boolean(recoverPasswordLoading);
  const otpError = Boolean(otpRecoverPinTypeErrors.includes(code));
  const microError = Boolean(recoverPinMicroTypeErrors.includes(code) || code >= 500);
  const showErrorModal = otpError || microError;
  const showSuccess = Boolean(maskedEmail && !showErrorModal);

  const FormClasses = cx('UserProfileSettingsPinReset', {
    'UserProfileSettingsPinReset--Loading': showLoading,
  });

  return (
    !showSuccess ?
      !showErrorModal ?
        <div className={ FormClasses }>
          { showLoading &&
            <LoadingScreen
              isDataLoading={ true }
              seatmap={ true }
              type='airplaneWindow'
            />
          }
          <Form
            className='UserProfileSettingsPinReset-form'
            onSubmit={ (e) => { e.preventDefault(); } } >
            <div className='UserProfileSettingsPinReset-form-section'>
              <button
                className='UserProfileRecoverPasswordOrPin-back'
                onClick={ onBackButtonClick }
                type='button'>
                <span className='Icon Icon--calendarArrowLeft' />
                <TranslatedCopy
                  className='UserProfileRecoverPasswordOrPin-back-Text'
                  copyID='PRO_HOME_FORGOT_LOGIN'
                />
              </button>
              <TranslatedCopy
                className='UserProfileSettingsPinReset-title Form-title'
                copyID='PROFILE_SETTINGS_PIN_HEADER'
                tagName='h4'
              />
              <ul className='UserProfileSettingsPinReset-rules-list'>
                { pinNumberRules.map( ({ copyId, matchRule }, index) => {
                  const pictogramId = matchRule ? 'circleOnNewFill' : 'circleOnDisabled';

                  return (
                    <li
                      className='UserProfileSettingsPinReset-item'
                      key={ index }>
                      { isMatch ?
                        <span className='allMatchIcon Icon Icon--check' />
                        :
                        <Pictogram
                          className='UserProfileSettingsPinReset-bullet-icon'
                          id={ pictogramId }
                        />
                      }
                      <TranslatedCopy
                        className='UserProfileSettingsPinReset-item-text'
                        copyID={ copyId }
                      />
                    </li>
                  );
                })
                }
              </ul>
              <Field
                className='UserProfileSettingsPinReset-newPin FormInput-wrapper FormInput-new-design tooltip-z-index'
                component={ FormInputText }
                labelClassModifier='passwd'
                labelCopyID='PROFILE_SETTINGS_NEW_PIN'
                maxLength={ 4 }
                name='newPin'
                onChange={ (e) => handleChange(e, 'newPin') }
                showIcon={ true }
                type={ 'password' }
              />
              <Field
                className='UserProfileSettingsPinReset-confirmPin FormInput-wrapper FormInput-new-design tooltip-z-index'
                component={ FormInputText }
                labelClassModifier='passwd'
                labelCopyID='PROFILE_SETTINGS_CONFIRM_PIN'
                maxLength={ 4 }
                name='confirmPin'
                onChange={ (e) => handleChange(e, 'confirmPin') }
                showIcon={ true }
                type={ 'password' }
              />
            </div>
            <div className='UserProfileSettingsPinReset-submit-section Form-submit'>
              <Btn
                btnType='submit'
                className='UserProfileSettingsPinReset-submit'
                copyID='CHANGE_PIN_BUTTON'
                disabled={ invalid }
                filledRed={ true }
                onBtnClick={ () => submitPinCode() }
              />
            </div>
            <TranslatedCopy
              className='UserProfileSettingsPinReset-captcha'
              copyID='PRO_HOME_FORGOT_CAPTCHA'
              tagName='p'
            />
          </Form>
        </div>
        :
        <>
          { otpError &&
            <FormOtpLoginError handleButtonClick={ handleOnRetryOtp } />
          }
          { microError &&
            <UserProfileErrorDisconnection
              onBackButtonClick={ handleOnRetryOtp }
              onCloseModal={ onCloseModal }
            />
          }
        </>
      :
      <UserProfileRecoverPasswordSuccess
        descriptionCopyId='PRO_HOME_NIP_SUCCESS_DESCRIPTION'
        onBackButtonClick={ onBackButtonClick }
        titleCopyId='PRO_HOME_NIP_SUCCESS_TITLE'
      />
  );
}

const mapStateToProps = function(state) {
  return {
    dispatch: state.dispatch,
    profileRecoverPasswordPin: state.Manage.profileRecoverPasswordPin,
    storefront: state.Manage.storefront,
  };
};

UserProfileRecoverPinForm = reduxForm({
  destroyOnUnmount: true,
  form: USER_PROFILE_RECOVER_PIN_FORM_ID,
  validate: userProfilePinValidation,
})(UserProfileRecoverPinForm);

UserProfileRecoverPinForm = connect(mapStateToProps)(UserProfileRecoverPinForm);

export default UserProfileRecoverPinForm;
